import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../../lib/icons';
import { PaelbiLogo } from '../common/Logo';
import { footerLinks, domiraBrand } from '../../data/config';
import { useLanguage } from '../../context/LanguageContext';

export function PaelbiFooter() {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-paelbi-line bg-paelbi-bg">
      <div className="mx-auto flex max-w-container flex-col gap-6 px-6 py-10 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-col gap-2">
          <PaelbiLogo />
          <p className="font-sans text-sm text-paelbi-ink/60">
            © 2025 Paelbi B&amp;B. {t('Tutti i diritti riservati.')}
          </p>
          <p className="font-sans text-xs text-paelbi-ink/50">{domiraBrand.tagline}</p>
        </div>

        <div className="flex items-center gap-6">
          {footerLinks.map((l) => (
            <Link key={l.label} to={l.path} className="font-sans text-sm text-paelbi-ink/70 transition-colors hover:text-paelbi-brown">
              {t(l.label)}
            </Link>
          ))}
          <div className="flex items-center gap-3">
            <a href="#" aria-label="Instagram" className="text-paelbi-ink/70 transition-colors hover:text-paelbi-brown"><Icon name="instagram" size={20} /></a>
            <a href="#" aria-label="Facebook" className="text-paelbi-ink/70 transition-colors hover:text-paelbi-brown"><Icon name="facebook" size={20} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default PaelbiFooter;
